import { useTheme } from '@mui/material';
import { TypeAnimation } from 'react-type-animation';

const loadingText = [
  'Processing data, please wait...',
  'Preparing analysis, thank you for your patience...',
  'Tips: Use specific examples for better analysis results.',
  'Processing information as requested...',
  'Tips: Avoid ambiguous words like ‘opinion’; clarify with sentiment context.',
  'Filtering topics and sentiments for the best results...',
  'Tips: Mention the time period, such as last week or this month.',
  'Checking the parameters you provided...',
  'Tips: Define the social media sources you want to analyze.',
  'Ensuring results match your search criteria...',
  'Tips: Specify the type of metrics you need, like sentiment or discussion volume.',
  'Gathering the latest data for analysis...',
  'Tips: Specify the sentiment you want to analyze – positive, negative, or neutral?',
  'Managing relevant social media data...',
  'Tips: Avoid the term ‘recent’, use a clear time period instead.',
  'Filtering results based on your request...',
  'Tips: Include a time frame for more precise data searches.',
  'Please wait a moment, analysis in progress...',
  'Tips: Use relevant keywords and context in your prompt.'
];

const libData = loadingText.flatMap((val) => [val, 3000]);
interface IProps {
  style?: React.CSSProperties;
}

export const LoadingText = ({ style = {} }: IProps) => {
  const theme = useTheme();
  return (
    <TypeAnimation
      sequence={libData}
      wrapper="span"
      speed={50}
      style={{
        display: 'inline-block',
        fontSize: 13,
        lineHeight: '16.9px',
        fontStyle: 'normal',
        color: theme.colors.alpha.black[100],
        ...style
      }}
      repeat={Infinity}
    />
  );
};
